export const NET_ABS_EMISSION_SCOPE_PEAK_ANNUAL_EMISSION =
  'Net Absolute Emissions Scope 1,2 & 3 (Peak annual emissions)';
export const NET_ABS_EMISSION_SCOPE_TOTAL_EMISSION =
  'Net Absolute Emissions Scope 1,2 & 3 (Total emissions)';
export const MARGIN_TO_CARBON_RATIO_AVG = 'Margin to Carbon Ratio (Average)';
export const DEAL_TERM = 'Deal Term';
export const TOTAL_CO2_EMISSION = 'Total CO2 emissions';
export const AVG_CARBON_INT = 'Avg Carbon Intensity**';
// New KPI labels for Step 03 Carbon KPIs table
export const VOLUME_WEIGHTED_AVG_CARBON_INT = 'Volume-weighted Avg Carbon Intensity (gCO2e/MJ)';
export const SCOPE3_CAT11_EMISSION = 'Scope 3 Category 11 Emission (KTPA)';
export const MARGIN_TO_CO2_RATIO = 'Margin to CO2 ratio';
export const EQUITY_SCOPE_CARBON_PEAK_ANNUAL_EMISSION =
  'Equity Scope 1&2 Carbon (Peak annual emissions)';
export const OPERATED_SCOPE = 'Operated Scope 1&2 (MTPA)';
export const EQUITY_SCOPE = 'Equity Scope 1&2 (MTPA)';
export const NET_ABSOLUTE_EMISSIONS = 'Net Absolute Emissions (MTPA)';
export const ASSET_SCOPE1_CI = 'Scope 1 Combustion Carbon Intensity';
export const TECH_SOURCE_COLUMN = 'Tech Source, ';
export const TECH_SOURCE_COLUMN_POWER = 'Power Output from Tech Source, ';
export const PRODUCTS_COLUMN = 'Products, ';
export const GVCET = 'Gas value chain emissions-Thermal';
export const FUEL_CO2E = 'Fuel CO2e';
export const LNG_NCF_CI = 'LNG NCF intensity';
export const GAS_END_USE_CF_CI = 'Gas end-use intensity';
export const MMBTU = 'MMBTU';
export const MWH = 'MWh';
export const KBBL = 'KBBL';
export const TECHSOURCE_TWH = 'Tech Source TWh';
export const PJ = 'PJ';
export const NATURAL_GAS = 'Natural Gas';
export const POWER = 'Power';
export const PIPELINE_GAS = 'Pipeline Gas';
export const AMERICAS = 'Americas';
export const ASIA = 'Asia';
export const AUSTRALIA = 'Australia';
export const EUROPE = 'Europe';
export const GLOBAL = 'Global';
export const AFRICA = 'Africa';
export const WIND = 'Wind';
export const SOLAR = 'Solar';
export const HYDROPOWER = 'Hydropower';
export const BIOMASS = 'Biomass';
export const GEOTHERMAL = 'Geothermal';
export const OIL = 'Oil';
export const COAL = 'Coal';
export const GRID = 'Grid';
export const GAS_FIRED_GENERATION = 'Gas Fired Generation';
export const DR_POWER_OTHERS = 'DR Power Others';
export const SLMT = 'SLMT';
export const SHELL_ASSET = 'Shell Asset';
export const THIRD_PARTY = 'Third Party';
export const TBTU = 'TBTU';
export const FEEDBACK_LINK = 'https://forms.office.com/e/PWgg8Ln0WV';
export const HELP_LINK =
  'https://eu001-sp.shell.com/:w:/r/sites/AAAAA0900/Documents/STSE_PRJ2154223_Carbon%20Management%20Framework/CPM/Product%20Management/User%20Instructions/Carbon%20KPI%20Calculator.docx?d=w4f90f8a01f43453d8bac52182abfb90c&csf=1&web=1&e=GaKYqs';
export const FEEDBACK_LABEL = 'Feedback';
export const HELP_LABEL = 'Help';
export const DOWNLOAD_DEALS = 'Download Deals';
export const DELETE_DEALS = 'Delete Deals';
export const UPDATE_DEALS = 'Update Deals in Crabon Dashboard';
export const SERVICE_FAILURE_CONSOLE_LOG = 'Get output KPI service failure =>';
export const API_VERSION_ONE = 'api/v1/';
export const BROWNFIELD = 'BROWNFIELD';
export const GREENFIELD = 'GREENFIELD';
export const RNG = 'RNG';
export const COUNTRY = 'Country';
export const COUNTRY_ASSET_OF_SUPPLY = 'Country/Asset of Supply';
export const TYPE_OF_SUPPLY = 'Type of Supply';
export const MESSAGES = {
  peakAnnualEmmision: {
    below50KtaMessage:
      'There are <strong>no specific Carbon requirements</strong> (Equity Scope 1&2 <0.050 mtCO2e; Carbon Significant threshold). Proceed without Carbon Functional Approval',
    between50To200KTAmessage:
      'This opportunity is <strong>Carbon Significant</strong>  (Equity Scope 1&2 (Peak Annual Emissions) > 0.050 mtCO2e and < 0.200 mtCO2e)',
    above200KTAmessage:
      'This opportunity is <strong>Carbon Critical</strong> (Equity Scope 1&2 (Peak Annual Emissions) > 0.200 mtCO2e)',
  },
  performanceStandard: {
    carbonCritical: {
      contactInfo:
        'Please contact the following for Carbon Functional Support: Moene, Robert GSNL-PTS/ES robert.moene@shell.com',
      assetBrownfield: {
        efficiencyAbove57Info:
          'Opportunity <strong>Does Meet</strong> Performance Standard (Brownfield >=58% LHV Efficiency)',
        efficiencyBelow58Info:
          'Opportunity <strong>Does Not Meet</strong> Performance Standard (Brownfield <58% LHV efficiency)',
      },
      assetGreenfield: {
        efficiencyAbove59Info:
          'Opportunity <strong>Does Meet</strong> Performance Standard (Greenfield >=60% LHV Efficiency)',
        efficiencyBelow60Info:
          'Opportunity <strong>Does Not Meet</strong> Performance Standard (Greenfield <60% LHV efficiency)',
      },
    },
    carbonSignificant: {
      contactInfo:
        'Please contact the following for Carbon Functional Support: Cray, David GSCA-PTS/ED David.Cray@shell.com',
      assetBrownfield: {
        efficiencyAbove39Info:
          'Opportunity <strong>Does Meet</strong> Performance Standard (Brownfield >=40% LHV Efficiency)',
        efficiencyBelow40Info:
          'Opportunity <strong>Does Not Meet</strong> Performance Standard (Brownfield <40% LHV efficiency)',
      },
      assetGreenfield: {
        efficiencyAbove41Info:
          'Opportunity <strong>Does Meet</strong> Performance Standard (Greenfield >=42% LHV Efficiency)',
        efficiencyBelow42Info:
          'Opportunity <strong>Does Not Meet</strong> Performance Standard (Greenfield  <42% LHV efficiency)',
      },
    },
  },
  operatingModel: {
    sovOrNov: 'Performance Standard is <strong>Mandatory</strong> (equity investment)',
    lease: 'Performance Standard is <strong>Best Practice</strong> (lease)',
  },
};
export const POWER_PERFORMANCE_STANDARD = 'Power Performance Standard';
export const POWER_PERFORMANCE_STANDARD_DESCRIPTION =
  'Power Performance Standard evaluation is a control framework requirement for Equity Investments and a best practice for Leases.';
export const LAST_UPDATE_TIMESTAMP = 'LAST_UPDATE_TIMESTAMP';
export const FOOT_NOTE =
  'For Pipeline gas commodity selection, Value Chain Carbon Intensity unit of measure is gCO2e/MJ and for Power commodity it is tCO2e/MWh.';
export const GROSS_MARGIN_MESSAGE =
  'Gross Margin: the total margin (used in Economics) across all the years for the deal/project';
export const KPI_SUMMARY = 'KPI Summary';
export const UNIT_FOR_MEASURE_CONVERTER = 'UOM and FX rates converter';
export const UNIT_FOR_MEASURE_CONVERTER_LINK =
  'https://apps.powerapps.com/play/e/af5c03df-f395-405c-a93f-87a7408adb36/a/2fecfd69-772f-411e-9f07-9150929a8013?tenantId=db1e96a8-a3da-442a-930b-235cac24cd5c&hint=6f70da29-d4b2-4be0-9c80-1be6671e1805&sourcetime=1718012337324';
export const contactPerson = [
  { email: 'David.Cray@shell.com', name: 'David Cray' },
  { email: 'robert.moene@shell.com', name: 'Robert Moene' },
];
export const CARBON_SIGNIFICANT = 'carbonSignificant';
export const CARBON_CRITICAL = 'carbonCritical';
export const ASSET_BROWNFIELD = 'assetBrownfield';
export const ASSET_GREENFIELD = 'assetGreenfield';
export const MTCO2E = 'mtCO2e';
export const MCR_AVG_UOM = '$/tCO2e';
export const FETCH_ERROR = 'Error fetching data';
export const DEAL_MOVED = 'Deal moved to carbon dashboard';
export const DEAL_REMOVED = 'Deal removed from carbon dashboard';
export const DEAL_DELETED = 'Deals deleted successfully';
export const SELECT_DEALS = 'Please select atleast one deal to delete.';

// Region-Country Mapping (Static - to be replaced by API when ready)
export const REGION_COUNTRY_MAPPING: Record<string, string[]> = {
  Global: ['Global'],
  Asia: [
    'Hong Kong',
    'Malaysia',
    'Thailand',
    'Oman',
    'Pakistan',
    'Philippines',
    'Singapore',
    'India',
    'Indonesia',
    'UAE',
    'China',
  ],
  Europe: [
    'Italy',
    'France',
    'Turkey',
    'United Kingdom',
    'Bulgaria',
    'Czech Republic',
    'Hungary',
    'Poland',
    'Slovakia',
    'Austria',
    'Germany',
    'Switzerland',
    'Netherlands',
    'Luxembourg',
    'Belgium',
  ],
  Americas: ['USA', 'Canada', 'Mexico'],
  Africa: ['Africa'],
};
export const allowedCommoditiesForSEandDRevp = ['pipelinegas', 'rng', 'power'];
export const allowedCommoditesForSlmtRevp = ['lng', 'biolng', 'cclng'];

export const techSourcePermitted = [
  'wind',
  'solar',
  'hydropower',
  'biomass',
  'geothermal',
  'oil',
  'coal',
  'grid',
];
// Intensity Feedstock data for T&S Products - Static (from Excel specification)
// Units: gCO2e/MJ_LHV
// Note: Region-specific values; 'Default' is used when region doesn't match
export const TS_PRODUCTS_INTENSITY_FEEDSTOCK: Record<
  string,
  Record<string, { value: number; unit: string }>
> = {
  Gasoline: {
    Americas: { value: 83.5, unit: 'gCO2e/MJ_LHV' },
    Africa: { value: 86.4, unit: 'gCO2e/MJ_LHV' },
    Asia: { value: 85, unit: 'gCO2e/MJ_LHV' },
    Europe: { value: 83.5, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 84.1, unit: 'gCO2e/MJ_LHV' },
  },
  Ethanol: {
    Brazil: { value: 32.4, unit: 'gCO2e/MJ_LHV' },
    Argentina: { value: 45.6, unit: 'gCO2e/MJ_LHV' },
    Belgium: { value: 57.3, unit: 'gCO2e/MJ_LHV' },
    Canada: { value: 45.6, unit: 'gCO2e/MJ_LHV' },
    Denmark: { value: 56.8, unit: 'gCO2e/MJ_LHV' },
    France: { value: 40.6, unit: 'gCO2e/MJ_LHV' },
    India: { value: 30.9, unit: 'gCO2e/MJ_LHV' },
    Philippines: { value: 39, unit: 'gCO2e/MJ_LHV' },
    SIETCo: { value: 45.6, unit: 'gCO2e/MJ_LHV' },
    STR: { value: 43.9, unit: 'gCO2e/MJ_LHV' },
    Thailand: { value: 33.6, unit: 'gCO2e/MJ_LHV' },
    Turkey: { value: 44.5, unit: 'gCO2e/MJ_LHV' },
    'United States': { value: 45.4, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 39.7, unit: 'gCO2e/MJ_LHV' },
  },
  Diesel: {
    Americas: { value: 85.8, unit: 'gCO2e/MJ_LHV' },
    Africa: { value: 88.3, unit: 'gCO2e/MJ_LHV' },
    Asia: { value: 86.9, unit: 'gCO2e/MJ_LHV' },
    Europe: { value: 85.3, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 86, unit: 'gCO2e/MJ_LHV' },
  },
  HVO: {
    Average: { value: 27.6, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 27.6, unit: 'gCO2e/MJ_LHV' },
  },
  FAME: {
    Argentina: { value: 18.7, unit: 'gCO2e/MJ_LHV' },
    Brazil: { value: 21, unit: 'gCO2e/MJ_LHV' },
    Canada: { value: 18.4, unit: 'gCO2e/MJ_LHV' },
    Denmark: { value: 64.2, unit: 'gCO2e/MJ_LHV' },
    'Eco Oils': { value: 64.2, unit: 'gCO2e/MJ_LHV' },
    France: { value: 32.8, unit: 'gCO2e/MJ_LHV' },
    'Hong Kong': { value: 16.1, unit: 'gCO2e/MJ_LHV' },
    Indonesia: { value: 58.6, unit: 'gCO2e/MJ_LHV' },
    Malaysia: { value: 58.6, unit: 'gCO2e/MJ_LHV' },
    Philippines: { value: 19.6, unit: 'gCO2e/MJ_LHV' },
    Poland: { value: 42.1, unit: 'gCO2e/MJ_LHV' },
    SIETCo: { value: 16.2, unit: 'gCO2e/MJ_LHV' },
    STR: { value: 27.8, unit: 'gCO2e/MJ_LHV' },
    SZTP: { value: 16.1, unit: 'gCO2e/MJ_LHV' },
    Thailand: { value: 58.6, unit: 'gCO2e/MJ_LHV' },
    Turkey: { value: 21.3, unit: 'gCO2e/MJ_LHV' },
    'United Kingdom': { value: 27.3, unit: 'gCO2e/MJ_LHV' },
    'United States': { value: 18, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 27.7, unit: 'gCO2e/MJ_LHV' },
  },
  LPG: {
    Americas: { value: 75.7, unit: 'gCO2e/MJ_LHV' },
    Africa: { value: 78.2, unit: 'gCO2e/MJ_LHV' },
    Asia: { value: 76.7, unit: 'gCO2e/MJ_LHV' },
    Europe: { value: 75.2, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 75.8, unit: 'gCO2e/MJ_LHV' },
  },
  'Fuel Oil': {
    Americas: { value: 91.5, unit: 'gCO2e/MJ_LHV' },
    Africa: { value: 94, unit: 'gCO2e/MJ_LHV' },
    Asia: { value: 92.6, unit: 'gCO2e/MJ_LHV' },
    Europe: { value: 91, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 91.7, unit: 'gCO2e/MJ_LHV' },
  },
  Kerosene: {
    Americas: { value: 85, unit: 'gCO2e/MJ_LHV' },
    Africa: { value: 87.5, unit: 'gCO2e/MJ_LHV' },
    Asia: { value: 86.1, unit: 'gCO2e/MJ_LHV' },
    Europe: { value: 84.5, unit: 'gCO2e/MJ_LHV' },
    Default: { value: 85.2, unit: 'gCO2e/MJ_LHV' },
  },
};

// Scope 3 CAT11 (Tank to Wheel) CI Factors for T&S Products - Static (from Excel specification)
// Units: gCO2e/MJ_LHV
export const TS_PRODUCTS_CAT11_FACTORS: Record<
  string,
  { pathway: string; productType: string; value: number; unit: string }
> = {
  Gasoline: { pathway: 'Oil', productType: 'Gasoline', value: 71.46, unit: 'gCO2e/MJ_LHV' },
  Diesel: { pathway: 'Oil', productType: 'Diesel/Gasoil', value: 73.33, unit: 'gCO2e/MJ_LHV' },
  Kerosene: { pathway: 'Oil', productType: 'Kerosene', value: 72.54, unit: 'gCO2e/MJ_LHV' },
  'Fuel Oil': { pathway: 'Oil', productType: 'Fuel Oil', value: 79.02, unit: 'gCO2e/MJ_LHV' },
  LPG: { pathway: 'Oil', productType: 'LPG', value: 62.94, unit: 'gCO2e/MJ_LHV' },
  Ethanol: { pathway: 'Biofuels', productType: 'Ethanol', value: 0.55, unit: 'gCO2e/MJ_LHV' },
  HVO: { pathway: 'Biofuels', productType: 'HVO', value: 0.24, unit: 'gCO2e/MJ_LHV' },
  FAME: { pathway: 'Biofuels', productType: 'FAME', value: 1.18, unit: 'gCO2e/MJ_LHV' },
};

// Type of Supply options for SLMT - Static, to be replaced by API when ready
// TODO: TYPE_OF_SUPPLY_OPTIONS is static. Replace with API call once backend is ready
// API endpoint should return list of available Type of Supply options (e.g., Shell Asset, Third Party, IG Asset)
export const TYPE_OF_SUPPLY_OPTIONS = [
  { value: 'Shell Asset', label: 'Shell Asset' },
  { value: 'Third Party', label: 'Third Party' },
  { value: 'IG Asset', label: 'IG Asset' },
];

// SLMT Commodity options - Static, to be replaced by API when ready
// TODO: SLMT_COMMODITY_OPTIONS is static. Replace with API call once backend is ready
// API endpoint should return list of commodities available for SLMT (LNG, BioLNG, CCLNG)
export const SLMT_COMMODITY_OPTIONS = [
  { value: 'LNG', label: 'LNG' },
  { value: 'BioLNG', label: 'BioLNG' },
  { value: 'CCLNG', label: 'CCLNG' },
];

// Type of Supply to Country/Asset mapping for SLMT - Static, to be replaced by API when ready
// TODO: TYPE_OF_SUPPLY_COUNTRY_MAPPING is static. Replace with API call once backend is ready
// API endpoint should accept typeOfSupply and return list of available countries/assets for that type
// Example: GET /api/slmt/countries?typeOfSupply=IG Asset
export const TYPE_OF_SUPPLY_COUNTRY_MAPPING: Record<string, string[]> = {
  'Shell Asset': [
    'Australia - Gorgon',
    'Australia - NWS',
    'Australia - Prelude',
    'Australia - QGC',
    'Brunei',
    'Egypt',
    'Nigeria',
    'Oman',
    'Peru',
    'Qatar - Qatar',
    'Qatar - NFS',
    'Qatar - NFE',
    'UAE',
    'Trinidad',
    'Canada',
    'Mashreq',
  ],
  'Third Party': [
    'Algeria',
    'Angola',
    'Argentina',
    'Australia',
    'Belgium',
    'Brazil',
    'Brunei',
    'Cameroon',
    'Canada',
    'China',
    'Egypt',
    'Equatorial Guinea',
    'France',
    'Germany',
    'India',
    'Indonesia',
    'Italy',
    'Japan',
    'Malaysia',
    'Mozambique',
    'Netherlands',
    'Nigeria',
    'Norway',
    'Oman',
    'Papua New Guinea',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Russia',
    'Singapore',
    'South Korea',
    'Spain',
    'Trinidad and Tobago',
    'Turkey',
    'UAE',
    'United Kingdom',
    'United States of America',
    'Yemen',
    'Other',
  ],
  'IG Asset': [
    'Australia - Gorgon',
    'Global LNG',
    'Qatar - NFE',
  ],
};

// SLMT Carbon Intensities (gCO2e/MJ) - Static data from specification
// Structure: [Type of Supply][Commodity][Country/Asset][Year]
// TODO: SLMT_CARBON_INTENSITIES is static data. Replace with API call once backend is ready
// API endpoint should accept: typeOfSupply, commodity, country/asset, and return carbon intensity data for all years
export const SLMT_CARBON_INTENSITIES: Record<string, Record<string, Record<string, Record<number, number>>>> = {
  'IG Asset': {
    'LNG': {
      'Australia - Gorgon': { 2026: 68.40, 2027: 68.40, 2028: 68.40, 2029: 68.40, 2030: 68.40, 2031: 68.40, 2032: 68.40, 2033: 68.40, 2034: 68.40, 2035: 68.40 },
      'Australia - NWS': { 2026: 67.50, 2027: 67.50, 2028: 67.50, 2029: 67.50, 2030: 67.50, 2031: 67.50, 2032: 67.50, 2033: 67.50, 2034: 67.50, 2035: 67.50 },
      'Australia - Prelude': { 2026: 72.10, 2027: 72.10, 2028: 72.10, 2029: 72.10, 2030: 72.10, 2031: 72.10, 2032: 72.10, 2033: 72.10, 2034: 72.10, 2035: 72.10 },
      'Australia - QGC': { 2026: 68.40, 2027: 68.40, 2028: 68.40, 2029: 68.40, 2030: 68.40, 2031: 68.40, 2032: 68.40, 2033: 68.40, 2034: 68.40, 2035: 68.40 },
      'Brunei': { 2026: 71.00, 2027: 71.00, 2028: 71.00, 2029: 71.00, 2030: 71.00, 2031: 71.00, 2032: 71.00, 2033: 71.00, 2034: 71.00, 2035: 71.00 },
      'Egypt': { 2026: 84.40, 2027: 84.40, 2028: 84.40, 2029: 84.40, 2030: 84.40, 2031: 84.40, 2032: 84.40, 2033: 84.40, 2034: 84.40, 2035: 84.40 },
      'Nigeria': { 2026: 72.40, 2027: 72.40, 2028: 72.40, 2029: 72.40, 2030: 72.40, 2031: 72.40, 2032: 72.40, 2033: 72.40, 2034: 72.40, 2035: 72.40 },
      'Oman': { 2026: 73.60, 2027: 73.60, 2028: 73.60, 2029: 73.60, 2030: 73.60, 2031: 73.60, 2032: 73.60, 2033: 73.60, 2034: 73.60, 2035: 73.60 },
      'Peru': { 2026: 71.20, 2027: 71.20, 2028: 71.20, 2029: 71.20, 2030: 71.20, 2031: 71.20, 2032: 71.20, 2033: 71.20, 2034: 71.20, 2035: 71.20 },
      'Qatar - NFE': { 2026: 56.50, 2027: 63.49, 2028: 62.30, 2029: 62.30, 2030: 62.30, 2031: 62.30, 2032: 62.30, 2033: 62.30, 2034: 62.30, 2035: 62.30 },
      'Qatar - Qatar': { 2026: 66.90, 2027: 66.90, 2028: 66.90, 2029: 66.90, 2030: 66.90, 2031: 66.90, 2032: 66.90, 2033: 66.90, 2034: 66.90, 2035: 66.90 },
      'Qatar - NFS': { 2026: 56.50, 2027: 56.50, 2028: 63.12, 2029: 62.52, 2030: 62.52, 2031: 62.52, 2032: 62.52, 2033: 62.52, 2034: 62.52, 2035: 62.52 },
      'UAE': { 2026: 56.50, 2027: 56.50, 2028: 56.50, 2029: 60.89, 2030: 60.89, 2031: 60.89, 2032: 60.89, 2033: 60.89, 2034: 60.89, 2035: 60.89 },
      'Trinidad': { 2026: 70.10, 2027: 70.10, 2028: 70.10, 2029: 70.10, 2030: 70.10, 2031: 70.10, 2032: 70.10, 2033: 70.10, 2034: 70.10, 2035: 70.10 },
      'Canada': { 2026: 60.11, 2027: 60.12, 2028: 60.13, 2029: 60.10, 2030: 60.11, 2031: 60.07, 2032: 61.98, 2033: 60.88, 2034: 60.81, 2035: 60.80 },
      'Mashreq': { 2026: 69.70, 2027: 69.70, 2028: 69.70, 2029: 69.70, 2030: 69.30, 2031: 63.70, 2032: 63.20, 2033: 63.20, 2034: 63.20, 2035: 63.30 },
    },
    'BioLNG': {
      'Australia - Gorgon': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Australia - NWS': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Australia - Prelude': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Australia - QGC': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Brunei': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Egypt': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Nigeria': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Oman': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Peru': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Qatar - NFE': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Qatar - Qatar': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Qatar - NFS': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'UAE': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Trinidad': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Canada': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
      'Mashreq': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
    },
    'CCLNG': {
      'Australia - Gorgon': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Australia - NWS': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Australia - Prelude': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Australia - QGC': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Brunei': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Egypt': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Nigeria': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Oman': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Peru': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Qatar - NFE': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Qatar - Qatar': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Qatar - NFS': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'UAE': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Trinidad': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Canada': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
      'Mashreq': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
    },
  },
  '3P/unknown': {
    'LNG': {
      'Global/Any': { 2026: 69.90, 2027: 69.90, 2028: 69.90, 2029: 69.90, 2030: 69.90, 2031: 69.90, 2032: 69.90, 2033: 69.90, 2034: 69.90, 2035: 69.90 },
    },
    'BioLNG': {
      'Global/Any': { 2026: 16.10, 2027: 16.10, 2028: 16.10, 2029: 16.10, 2030: 16.10, 2031: 16.10, 2032: 16.10, 2033: 16.10, 2034: 16.10, 2035: 16.10 },
    },
    'CCLNG': {
      'Global/Any': { 2026: 0.00, 2027: 0.00, 2028: 0.00, 2029: 0.00, 2030: 0.00, 2031: 0.00, 2032: 0.00, 2033: 0.00, 2034: 0.00, 2035: 0.00 },
    },
  },
};

// TODO: SLMT_CONVERSION_FACTORS are static. Replace with API call once backend is ready
// API should return conversion factors based on commodity type
// SLMT Conversion Factors
export const SLMT_CONVERSION_FACTORS = {
  TBTU_HHV_TO_MT_LNG: 52.69,
  LNG_KG_TO_MJ_LHV: 50.1,
};
